import { DEFAULT_LOCALE, isLocale, type Locale } from "./registry";

export const LOCALE_STORAGE_KEY = "jourio.admin.locale";

export interface LocaleStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export type LocaleStorageGetter = () => LocaleStorage;

const browserStorage: LocaleStorageGetter = () => window.localStorage;

export function readLocale(
  getStorage: LocaleStorageGetter = browserStorage,
): Locale {
  try {
    const stored = getStorage().getItem(LOCALE_STORAGE_KEY);
    return isLocale(stored) ? stored : DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
}

export function writeLocale(
  locale: Locale,
  getStorage: LocaleStorageGetter = browserStorage,
): void {
  try {
    getStorage().setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Storage may be blocked or full; the choice then lives for this session only.
  }
}
